module.exports = __webpack_public_path__ + "static/media/5.a3c01362.jpg";